export const LOAD_BOOKING_INSTRUMENTS = "[BOOKING_INSTRUMENTS] LOAD_BOOKING_INSTRUMENTS";
export const LOAD_UNFILTERED_BOOKING_INSTRUMENTS = "[BOOKING_INSTRUMENTS] LOAD_UNFILTERED_BOOKING_INSTRUMENTS";
export const UPDATE_SEARCH_DROP_DOWN_FILTER = "[BOOKING_INSTRUMENTS] UPDATE_SEARCH_DROP_DOWN_FILTER";
export const SET_TV_MODE = "[BOOKINGS] SET_TV_MODE";
